import CityPageTemplate from "../city-template/CityPageTemplate";
import { wheatRidgeConfig } from "./data";

export default function WheatRidgePage() {
  return <CityPageTemplate config={wheatRidgeConfig} />;
}